import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import config from '../../helpers/config-helper';
import { IActionFormatter } from '../../models/ICommon';
import { formatMessage } from '../../translations/format-message';
import './Grid.css';

const appConfig = config();
const dateTimeFormat = appConfig.REACT_APP_DATE_TIME_FORMAT;

export const ActionFormatter =
  (actions: Array<IActionFormatter>) => (cell: any, row: any) => {
    return (
      <div className="d-flex">
        {actions.map((action: IActionFormatter, index: number) => {
          return (
            <button
              className={`btn btn-light-${action.varient} `}
              key={index}
              title={formatMessage(action.title)}
              type="button"
              disabled={action.isDisable && !row[action.dataField]}
              onClick={(event) => action.handler(row, event)}
            >
              <FontAwesomeIcon icon={action.icon} />
            </button>
          );
        })}
      </div>
    );
  };

export const CustomActionFormatter =
  (actions: Array<IActionFormatter>) => (cell: any, row: any) => {
    return (
      <>
        <div className="d-flex">
          {actions.map((action: IActionFormatter, index: number) => {
            return (
              <button
                className={`btn btn-light-${action.varient} btn-sm`}
                key={index}
                title={formatMessage(action.title)}
                type="button"
                disabled={(action.isDisable && !row[action.dataField]) || (action.title === 'edit' && row?.CurrentState === 'Complete')}
                onClick={(event) => action.handler(row, event)}
                hidden={action.hidden}
              >
                {action.icon}
              </button>
            );
          })}
        </div>
      </>
    );
  };

export const UserReserveButtonFormatter =
  (handler: any) => (cell: any, row: any) => {
    return (
      <div className="form-check form-switch p-0">
        <input
          className="form-check-input ms-0 pointer-events-none"
          type="checkbox"
          title={row.IsReserved ? 'Yes' : 'No'}
          role="switch"
          id="flexSwitchCheckChecked"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            handler(row, e);
          }}
          checked={row.IsReserved}
        />
      </div>
    );
  };
